import React from 'react';

// Artwork comes from the badge kit the app serves (app/public/surfaces/access/badges/v1/).
const KIT_BASE = '/surfaces/access/badges/v1/';

function pingLabel(ping) {
  if (!ping) return { text: 'No text, chat only', tone: null };
  if (ping.status !== 'sent') return { text: 'Text failed', tone: 'bad' };
  const at = ping.at ? new Date(ping.at) : null;
  // The date too: an older badge must not read as sent today.
  const time = at && !Number.isNaN(at.getTime())
    ? at.toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' })
    : '';
  return { text: time ? `Sent ${time}` : 'Sent', tone: 'good' };
}

// The care team's view of a milestone badge message: what was posted, whether a text went out,
// and the exact words the patient read, folded away.
export default function MilestoneSummary({ model, ping, body, patientFirstName }) {
  const who = patientFirstName || 'the patient';
  const whose = patientFirstName ? `${patientFirstName}'s` : "the patient's";
  const status = pingLabel(ping);
  return (
    <div className="chat-milestone">
      <div className="chat-milestone__head">
        <img className="chat-milestone__art" src={`${KIT_BASE}${model.art}`} alt="" width="36" height="36" />
        <div className="chat-milestone__head-text">
          <p className="body2 chat-milestone__title">Badge sent: {model.name}</p>
          <p className="detail1 chat-milestone__sub">
            Posted to {whose} app chat: “{model.title}”
          </p>
        </div>
      </div>
      <dl className="detail1 chat-milestone__facts">
        <dt>Text ping</dt>
        <dd className={status.tone ? `chat-milestone__ping chat-milestone__ping--${status.tone}` : 'chat-milestone__ping'}>
          {status.tone === 'good' && <span aria-hidden="true">✓ </span>}
          {status.text}
        </dd>
      </dl>
      <details className="disclosure">
        <summary className="detail1">
          What {who} saw <span className="disclosure__chevron" aria-hidden="true">›</span>
        </summary>
        <p className="detail1 chat-milestone__body">{body}</p>
      </details>
    </div>
  );
}
